export default __webpack_public_path__ + "1f80b1d87b19cd9345c2c38367d966a7.svg";